module.exports = __webpack_public_path__ + "static/media/Icons_stats_01.212114f1.svg";